import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=3c7edb24&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=3c7edb24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7edb24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SidebarElementsBadge: require('/home/travis/build/Polumathes/LTNG-Transact-Frontend/components/SidebarElements/Badge.vue').default})
